import {useCallback, useRef} from 'react';

import {IconOnlyButton} from 'shells/button/icon-only-button/icon-only-button';
import {PersonWarningIcon} from 'shells/icon';
import {StatusBadge} from 'shells/status-badge/status-badge';

interface Props {
    entityName: string;
    entityId: string;
    parentEntityName: string;
}

function useOpenDuplicatePopover(props: Props) {
    const duplicateRef = useRef<HTMLElement | null | undefined>(null);

    const handleDuplicateClick = useCallback(() => {
        if (duplicateRef.current) {
            const $element = $(duplicateRef.current);

            const handlePopoverClose = () => {
                $element.off('popoverWasClosed', handlePopoverClose);
            };

            $element.on('popoverWasClosed', handlePopoverClose);

            Popover.load({
                url: '/de-duplication/popover.json',
                data: {
                    entityName: props.entityName,
                    entityId: props.entityId,
                    parentEntityName: props.parentEntityName,
                    orientationOverride: 'east',
                },
                appendTo: $element,
                noLoadingIndicator: true,

                error: function () {
                    $element.off('popoverWasClosed', handlePopoverClose);
                },
            });
        }
    }, [props.entityName, props.entityId, props.parentEntityName]);

    return {duplicateRef, handleDuplicateClick};
}

export function PeepDuplicateBadge(props: Props) {
    const {duplicateRef, handleDuplicateClick} = useOpenDuplicatePopover(props);

    if (NutClientConfig.hasCoreEntityFullHeightSidebarFF) {
        return (
            <IconOnlyButton
                icon={PersonWarningIcon}
                onClick={handleDuplicateClick}
                variant='danger'
                tooltipText='Duplicate?'
                getButtonRef={(ref: HTMLElement | null) => {
                    duplicateRef.current = ref;
                }}
                size='large'
            />
        );
    }

    return (
        <StatusBadge
            level='alert'
            text='Duplicate'
            customIcon={PersonWarningIcon}
            onClick={handleDuplicateClick}
            getRef={(ref) => {
                duplicateRef.current = ref;
            }}
            size='small'
        />
    );
}
